<template>
  <v-expansion-panels class='mt-2' v-model='expand' dense>
    <v-expansion-panel>
      <v-expansion-panel-title>
        HotLinux ／ ご相談はこちらから
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-list>
          <!--
          <v-list-item>
            <slot/>
          </v-list-item>
          -->
          <v-list-item
            :prepend-avatar="require('/src/assets/hot-linux_logos.png')"
            :append-icon="mdiThumbUpOutline"
            to="/inquiryform"
          >
          <template v-slot:append>

            <v-icon
              color='deep-purple'
            >mdi-thumb-up-outline</v-icon>
            <span class='text-subtitle-1'>おすすめ</span>
          </template>
            このサイトからご相談<!-- （受注実績：{{サイト情報row.サイト受注数}}件） -->

          </v-list-item>
          <v-list-item
            :prepend-avatar="require('/src/assets/coconara_logo.jpeg')"
            href="https://coconala.com/users/2399401"
            target="_blank"
          >
            ココナラからご相談<!-- （受注実績：{{サイト情報row.ココナラ受注数}}件） -->
          </v-list-item>
          <v-list-item
            :prepend-avatar="require('/src/assets/lancers_logo.svg')"
            href="https://www.lancers.jp/profile/masashi012"
            target="_blank"
          >
            ランサーズからご相談<!-- （受注実績：{{サイト情報row.ランサーズ受注数}}件） -->
          </v-list-item>
          <!--
          <v-list-item
            href="https://crowdworks.jp/public/employees/5713917"
            target="_blank"
          >
            クラウドワークス経由でのご相談
          </v-list-item>
          -->
          <!--
          <v-list-item
            href="https://www.facebook.com/hotlinux"
            :prepend-avatar="require('/src/assets/Facebook_Logo_Primary.png')"
            target="_blank"
          >
            Facebookでご相談
          </v-list-item>
          -->
          <!--
          <v-list-item
            href="https://twitter.com/masashi012"
            :prepend-avatar="require('/src/assets/logo-black.png')"
            target="_blank"
          >
            X(Twitter)でご相談
          </v-list-item>
          -->
          <v-btn
            block
            color="success text-h6"
            @click='onClickLine()'
            >LINEでのご相談も受付中です</v-btn>

        </v-list>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    data(){
      return {
        サイト情報row:{},
        expand:[0],
      };
    },

    mounted(){
      this.サイト情報取得()
      setTimeout(() => {
        if(window.innerWidth>1000){
          this.expand = [0]
        }else{
          this.expand = []
        }
      },1000)

    },

    methods:{
      サイト情報取得(){
        this.$emit('overlay');
        let url = './api/api.php';
        let data = {
          func:"サイト情報取得",
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          this.サイト情報row = result.サイト情報row;
          this.$emit('overlay');
        })
        .catch(error =>{
          console.log(error)
          alert('取得できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },

      onClickLine(){
        window.open("https://lin.ee/XRhQTGa")
      }
    }

  }
</script>